import { useEffect, useRef } from 'react';
import { Box, Stack } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import './style.css'

import { Autoplay, EffectCoverflow } from 'swiper/modules';
import { NavLink, titleToUrl, useSelector } from '../../../imports/generalImport';
import MobileSectionTitle from '../mobileProductCard/MobileSectionTitle';


const MobileFeatureComponent = () => {
    const featuredData = useSelector((state) => state?.MobileHomepage?.allData?.featured);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.update();
        }
    }, [featuredData]);

    return (
        <Box
            component={"div"}
            sx={{
                my: 3,
                pt: 3.5,
                pb: 1.2,
                backgroundColor: "rgb(237 246 255)",
                '& .swiper': {
                    width: '100%',
                    padding: '20px 0',
                    
                },
                '& .swiper-slide': {
                    width: {
                        xs:'190px',
                        sm : 310
                    },
                    height: {
                        xs:'190px',
                        sm: 190
                    },
                    maxWidth: {
                        xs:'190px',
                        sm: 310
                    },
                    maxHeight: {
                        xs:'190px',
                        sm: 190
                    },

                    backgroundPosition: 'center',
                },
                '& .swiper-slide img': {
                    width: '100%',
                    display: 'block',
                    borderRadius: '4px'
                }
            }}
        >
            <Stack
                sx={{
                    pl: 1,
                }}
            >
                <MobileSectionTitle
                    sectionTitle={"Featured Gift Vouchers"}
                />
            </Stack>

            <Swiper
                ref={swiperRef}
                effect="coverflow"
                grabCursor
                centeredSlides
                slidesPerView="auto"
                loop
                autoplay={{
                    delay: 1000, // ✅ 1.5 seconds
                    disableOnInteraction: true, // continues autoplay even after user interaction
                }}
                coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}
                pagination={false}
                modules={[EffectCoverflow, Autoplay]}
                className="mySwiper"
            >
                {featuredData?.map((item) => {
                    const url = `/card-details/${item?.id}/${titleToUrl(item?.title)}${item?.url_utm ? `?${item?.url_utm}` : ''}`;

                    return (
                        <SwiperSlide key={`featuredData-${item?.id}`}>
                            <NavLink to={url} style={{ textDecoration: 'none' }}>
                                <Box
                                    component="img"
                                    src={item?.featured_img}
                                    alt={item?.title}
                                    loading="lazy"
                                    sx={{
                                        width: 132,
                                        height: 189,
                                        objectFit: 'cover',
                                        borderRadius: 2,
                                        boxShadow: 3,
                                        backgroundColor: 'transparent',
                                    }}
                                />
                            </NavLink>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </Box>
    )
}

export default MobileFeatureComponent


//     < Swiper
// effect = { 'coverflow'}
// grabCursor = { true}
// centeredSlides = { true}
// slidesPerView = { 'auto'}
// loop = { true}
// coverflowEffect = {{
//     rotate: 50,
//         stretch: 0,
//             depth: 100,
//                 modifier: 1,
//                     slideShadows: true,
// }}
// pagination = { false}
// modules = { [EffectCoverflow]}
// className = "mySwiper"
//     >
//     { featuredData?.map((item) => {
//     return (
//         <SwiperSlide key={`featuredData-${item?.id}`}>
//             <NavLink
//                 to={`/card-details/${item?.id}/${titleToUrl(item?.title)}`}
//                 style={{
//                     textDecoration: "none",
//                 }}
//             >
//                 <Box
//                     component={"img"}
//                     src={item?.featured_img}
//                     alt={item?.title}
//                     sx={{
//                         width: 132,
//                         height: 189
//                     }}
//                 />
//             </NavLink>
//         </SwiperSlide>
//     )
// })}
// </ >